var render = function render(){
  var _vm$company$logo, _vm$company$logo2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "w-100 h-100",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 166 / 36,
      "width": "166",
      "height": "36",
      "max-width": "166",
      "contain": "",
      "src": (_vm$company$logo = _vm.company.logo) === null || _vm$company$logo === void 0 ? void 0 : _vm$company$logo.src
    }
  }, [_c('v-fade-transition', [!((_vm$company$logo2 = _vm.company.logo) !== null && _vm$company$logo2 !== void 0 && _vm$company$logo2.src) ? _c('v-overlay', {
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('image-overlay', [_vm._v(_vm._s(_vm.company.name))])], 1) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }